import React, { Component } from 'react';

//componentes
import PlanillaV from './planillaV'

class Index extends Component {

    render(){
        return(
            <div>
                <PlanillaV />
            </div>
        );
    }

}
export default Index;